import { render, staticRenderFns } from "./AlertPopup.vue?vue&type=template&id=1309fe94&scoped=true&"
import script from "./AlertPopup.vue?vue&type=script&lang=js&"
export * from "./AlertPopup.vue?vue&type=script&lang=js&"
import style0 from "./AlertPopup.vue?vue&type=style&index=0&id=1309fe94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1309fe94",
  null
  
)

export default component.exports